(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const toggle = header.querySelector('.site-header__toggle');
  const mobilePanel = header.querySelector('.site-header__mobile-panel');
  const scrollSwitch = header.dataset.scrollSwitch === 'true';
  const overlayEnabled = header.dataset.overlay === 'true';
  const desktopQuery = window.matchMedia('(min-width: 750px)');
  const scrollRoot = (() => {
    const pageWrapper = document.querySelector('.page-wrapper');
    if (!pageWrapper) return window;

    const overflowY = getComputedStyle(pageWrapper).overflowY;
    if (overflowY === 'auto' || overflowY === 'scroll') {
      return pageWrapper;
    }

    return window;
  })();

  function getScrollTop() {
    return scrollRoot === window ? window.scrollY : scrollRoot.scrollTop;
  }

  function setHeaderHeight() {
    if (overlayEnabled && desktopQuery.matches && header.classList.contains('is-scrolled')) {
      return;
    }

    const height = header.offsetHeight;
    document.documentElement.style.setProperty('--site-header-height', `${height}px`);
    document.body.style.setProperty('--header-group-height', `${height}px`);
    document.body.style.setProperty('--header-height', `${height}px`);
  }

  function updateScrollState() {
    if (!scrollSwitch) return;
    header.classList.toggle('is-scrolled', desktopQuery.matches && getScrollTop() > 24);
  }

  function closeMobileMenu() {
    if (!toggle || !mobilePanel) return;
    toggle.setAttribute('aria-expanded', 'false');
    mobilePanel.hidden = true;
    header.classList.remove('is-mobile-open');
    setHeaderHeight();
  }

  function openMobileMenu() {
    if (!toggle || !mobilePanel) return;
    toggle.setAttribute('aria-expanded', 'true');
    mobilePanel.hidden = false;
    header.classList.add('is-mobile-open');
    setHeaderHeight();
  }

  setHeaderHeight();
  updateScrollState();

  scrollRoot.addEventListener('scroll', updateScrollState, { passive: true });
  window.addEventListener('resize', () => {
    setHeaderHeight();
    updateScrollState();
  });
  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', updateScrollState);
  } else if (typeof desktopQuery.addListener === 'function') {
    desktopQuery.addListener(updateScrollState);
  }

  if (toggle && mobilePanel) {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });

    mobilePanel.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeMobileMenu);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMobileMenu();
    });
  }

  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(setHeaderHeight).observe(header);
  }
})();
